import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';

import ptLocale from "date-fns/locale/pt-BR";
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';


//components
import CardFile from '../childrens/CardFile/.mixins/CardFile';
import Fornecedores from '../childrens/Fornecedores/.mixins/Fornecedores';

//css
import SectionCss from './Section-css';
const useStyles = SectionCss();

const CustomSwitch = withStyles((theme)=>({
    switchBase: {
      color: theme.palette.primary.main,
      '&$checked': {
        color: theme.palette.primary.main
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    checked: {},
    track: {},
}))(Switch);

function Section(props) {
    const classes = useStyles();

    const handleChange = name => event => {
        props.setState({
            [name]: event.target.checked
        });
    };
    
    return (
        <div className={classes.root}>
            <div className={'container'} style={{maxWidth:700}}>

                {props.state.isLoading &&
                <div align="center">
                    <CircularProgress />
                </div>
                }

                {!props.state.isLoading &&
                <Box component="span" m={1}>
                    <Paper className={classes.root}>
                        <div className={classes.boxForm}>
                            <Typography variant="h5" component="h3" className={classes.title}>
                                {props.state.tipo} {props.props.route.title}
                            </Typography>
                            <form 
                                id={"formSection"}
                                className={classes.container} 
                                noValidate 
                                autoComplete="off"
                                encType="multipart/form-data"
                            >
                                <TextField variant={"filled"}
                                    id="standard-name"
                                    label="Título"
                                    className={classes.textField}
                                    InputProps={{
                                        className: classes.multilineColor
                                    }}
                                    margin="normal"
                                    onChange={(e)=>{props.setState({titulo:e.target.value})}}
                                    value={props.state.titulo}
                                />
                                <TextField variant={"filled"}
                                    id="standard-multiline-static"
                                    label="Descrição"
                                    multiline
                                    rows="4"
                                    className={classes.textField}
                                    InputProps={{
                                        className: classes.multilineColor
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLabel
                                    }}
                                    margin="normal"
                                    onChange={(e)=>{props.setState({descricao:e.target.value})}}
                                    value={props.state.descricao}
                                />
                                {props.props.route.title.includes('contato') && props.state.gruposArray != null &&
                                   <FormControl className={classes.textFieldCheckbox}>
                                        <InputLabel htmlFor="age-simple">Grupo</InputLabel>
                                        <Select
                                            value={props.state.grupo_id}
                                            onChange={(e)=>{
                                                props.setState({grupo_id: e.target.value})
                                            }}
                                            inputProps={{
                                                name: 'grupo',
                                                id: 'grupo-simple'
                                            }}
                                            className={classes.select}
                                        >
                                            {props.state.gruposArray.map((grupo, i) => {
                                                return (
                                                    <MenuItem key={i} value={grupo.id}>{grupo.descricao}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                }

                                {props.props.route.title.includes("comunicado") &&
                                    <div style={{width:'98%'}}>
                                        <br/>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <MuiPickersUtilsProvider 
                                                    utils={DateFnsUtils}
                                                    locale={ptLocale}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        id="dt_lancamento"
                                                        label="Início Vigência"
                                                        format="dd/MM/yyyy"
                                                        invalidDateMessage="Data inválida"
                                                        cancelLabel="Cancelar"
                                                        onChange={(e)=>{props.setState({lancamento: e})}}
                                                        value={props.state.lancamento}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        InputProps={{
                                                            className: classes.multilineColor
                                                        }}
                                                        className={classes.textField}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <MuiPickersUtilsProvider 
                                                    utils={DateFnsUtils}
                                                    locale={ptLocale}
                                                >
                                                    <KeyboardDatePicker
                                                        margin="normal"
                                                        id="dt_termino"
                                                        label="Fim vigência"
                                                        format="dd/MM/yyyy"
                                                        invalidDateMessage="Data inválida"
                                                        cancelLabel="Cancelar"
                                                        onChange={(e)=>{props.setState({termino: e})}}
                                                        value={props.state.termino}
                                                        KeyboardButtonProps={{
                                                            'aria-label': 'change date',
                                                        }}
                                                        InputProps={{
                                                            className: classes.multilineColor
                                                        }}
                                                        className={classes.textField}
                                                    />
                                                </MuiPickersUtilsProvider>
                                            </Grid>
                                        </Grid>
                                        <br/>
                                    </div>
                                }
                                <br/>
                                <div className={classes.cardFile} align={'center'}>
                                    <CardFile {...props}/>
                                </div>
                                <br/>
                                {props.props.route.title.includes("comunicado") &&
                                    <div style={{width:'100%'}}>
                                        <FormControlLabel
                                            control={
                                                <CustomSwitch
                                                    checked={props.state.fl_all}
                                                    onChange={handleChange('fl_all')}
                                                    value="all"
                                                />
                                            }
                                            label={(props.state.fl_all)?"Todos fornecedores podem visualizar":"Apenas alguns fornecedores podem visualizar"}
                                        />
                                        {!props.state.fl_all &&
                                            <Fornecedores pai={props}/>
                                        }
                                    </div>
                                }
                                <br/>
                                <div className={classes.buttonAction} align="right">
                                    <Button className={classes.buttonCancelar} onClick={()=>{props.props.router.goBack()}}>
                                        Cancelar
                                    </Button>
                                    <Button variant="contained" color="primary" onClick={()=>{props.sendForm()}}>
                                        {(props.state.tipo === 'Editar')?'Salvar':'Salvar'}
                                    </Button>
                                </div>
                                <br/>
                            </form>
                        </div>
                    </Paper>
                </Box>
                }
             

            </div>
        </div>
    );
}

export default class SectionForm extends Component {

    render() {
        return(<Section {...this.props}/>);
    }

}